// Firebase utilities for push notifications
import { initializeFirebase, getFirebaseToken as getRealFirebaseToken } from '../config/firebase';

// Initialize Firebase
export function initializeFirebaseApp() {
    return initializeFirebase();
}

// Get FCM token
export async function getFirebaseToken() {
    try {
        const token = await getRealFirebaseToken();
        return token;
    } catch (error) {
        // Silently handle Firebase errors - they're expected if not configured
        const errorMessage = error?.message || error?.toString() || '';
        if (!errorMessage.includes('401') && !errorMessage.includes('Unauthorized')) {
            // Only log non-auth errors
            console.debug('Error getting FCM token:', errorMessage);
        }
        return null;
    }
}

// Request notification permission
export async function requestNotificationPermission() {
    if (!('Notification' in window)) {
        console.log('This browser does not support notifications');
        return false;
    }
    
    if (Notification.permission === 'granted') {
        return true;
    }
    
    if (Notification.permission === 'denied') {
        console.log('Notification permission denied');
        return false;
    }
    
    const permission = await Notification.requestPermission();
    return permission === 'granted';
}

// Setup notification click handler
export function setupNotificationClickHandler() {
    // Handle notification clicks
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.addEventListener('message', (event) => {
            if (event.data && event.data.type === 'NOTIFICATION_CLICK') {
                // Handle notification click
                console.log('Notification clicked:', event.data);
                
                // You can navigate to specific pages based on notification data
                if (event.data.url) {
                    window.location.href = event.data.url;
                }
            }
        });
    }
}
